module.exports = new Promise((resolve, reject) => {
		const isLocal = window.location.protocol === 'http:';
		if (!isLocal) {
			return reject();
		}

		const script = document.createElement('script');
		script.src = 'http://localhost:3016/remoteEntry.js';
		script.onload = () => {
			resolve(window.perio_chart);
		};
		script.onerror = (err) => {
			console.error('Failed to load local perio_chart... Retrying with stage deployment...', err);
			reject();
		};

		document.head.appendChild(script);
	}).catch(() => {
		return new Promise((resolve, reject) => {
			const host = window.location.host;
			const isProd = host.indexOf('p2.') >= 0;
			const url = isProd ? 'https://periochart.aspendental.com' : 'https://periochart-stage.aspendental.com';

			const script = document.createElement('script');
			script.src = url+'/remoteEntry.js';
			script.onload = () => {
				resolve(window.perio_chart);
			};
			script.onerror = (err) => {
				console.error('Failed to load deployed remote module!', err);
				reject();
			};

			document.head.appendChild(script);
		});
	});;